import React from "react";
import { array, object, string } from "prop-types";
import { connect } from "react-redux";
import { clamp, get } from "lodash";

import Organism1 from "./Organism1";
import Organism3 from "./Organism3";
import ComponentContainer from "../../layouts/component-container";

import { checkEmpty, componentProps } from "../../utils/utils";

import "./fiveStories1AdWithWidget.m.css";

const FiveStories1AdWithWidget = ({
  collectionSlug: parentCollectionSlug,
  collection,
  firstStoriesSet,
  widgetUrl,
  lang,
  section,
}) => {
  if (!firstStoriesSet && !(collection || collection.items || collection.items.length)) {
    return null;
  }

  let {
    widgetUrl: cWidgetUrl,
    widgetDesktopHeight,
    widgetMobileHeight,
    adSlot = lang === "en" ? "EnPalo_ROS_336x280_R1" : "News_336x280_R1",
    layoutName,
    numberOfCollectionsToShow = 0,
    numberOfStoriesShow = 5,
    showCollectionName,
  } = componentProps(collection);

  let titleCollection = collection;

  const widgetLink = checkEmpty(cWidgetUrl) || checkEmpty(widgetUrl);

  if (numberOfCollectionsToShow === 1) {
    // replace parent collection with child collection
    collection = collection.items?.find(({ type }) => type === "collection");
    if (!collection) return null;

    const { number_of_stories_to_show: show } = collection["associated-metadata"];
    numberOfStoriesShow = show;

    if (!showCollectionName) titleCollection = collection;
  }

  let storyList =
    firstStoriesSet ||
    collection.items?.filter(({ type }) => type === "story").splice(0, clamp(numberOfStoriesShow, 5));

  if (!storyList.length) {
    return null;
  }

  const styles = {
    "--current-widget-mobile-height": widgetMobileHeight ? widgetMobileHeight + "px" : undefined,
    "--current-widget-desktop-height": widgetDesktopHeight ? widgetDesktopHeight + "px" : undefined,
  };

  storyList = storyList.map(({ story }) => story);

  return (
    <ComponentContainer styleName="base" style={styles} collection={titleCollection}>
      <div styleName="wrapper">
        <Organism1 storyList={storyList.slice(0, 5)} />
        <Organism3
          widgetUrl={widgetLink}
          collectionSlug={parentCollectionSlug || collection?.slug}
          adSlot={adSlot}
          layoutName={layoutName}
          section={section}
        />
      </div>
    </ComponentContainer>
  );
};

FiveStories1AdWithWidget.propTypes = {
  collection: object,
  firstStoriesSet: array,
  widgetUrl: string,
  pageType: string,
  lang: string,
  section: object,
  collectionSlug: string,
};

FiveStories1AdWithWidget.storyLimit = 5;
FiveStories1AdWithWidget.nestedCollectionLimit = [5];

const mapStateToProps = (state) => ({
  pageType: get(state, ["qt", "pageType"], ""),
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

export default connect(mapStateToProps)(FiveStories1AdWithWidget);
